type Props = {
  collapsed?: boolean;
};

export default function SupportTicketsIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={collapsed ? "" : "relative left-[3px]"}
      >
        <path
          d="M19 9.94495C19 14.9155 14.9706 18.9449 10 18.9449M19 9.94495C19 4.97438 14.9706 0.944946 10 0.944946M19 9.94495H15.25M10 18.9449C5.02944 18.9449 1 14.9155 1 9.94495M10 18.9449V15.1949M1 9.94495C1 4.97438 5.02944 0.944946 10 0.944946M1 9.94495H4.75M10 0.944946V4.69495M10 15.1949C12.8995 15.1949 15.25 12.8444 15.25 9.94495M10 15.1949C7.10051 15.1949 4.75 12.8444 4.75 9.94495M4.75 9.94495C4.75 7.04545 7.10051 4.69495 10 4.69495M15.25 9.94495C15.25 7.04545 12.8995 4.69495 10 4.69495M13.7123 13.6573L16.364 16.3089M6.28769 13.6573L3.63604 16.3089M13.7123 6.23264L16.364 3.58099M6.28769 6.23264L3.63604 3.58099"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
